export default "__VITE_ASSET__Cf77LgkS__"